import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';

import { PaymentOptionSkeletonProps } from './PaymentOptionSkeleton.types';

const PaymentOptionSkeleton: React.FC<PaymentOptionSkeletonProps> = ({ className }) => {
  return (
    <div className={`relative flex flex-justify p4 ${className} content-center`}>
      <div className='flex flex-row'>
        <Skeleton variant='circle' width={24} height={24} className="mr2 mt2" />
        <div className='flex flex-column ml2'>
          <BaseSkeleton width={150} height={30} className='mb2'/>
          <BaseSkeleton width={200} className="mb2" />
        </div>
      </div>
      <BaseSkeleton width={100} height={24} />
    </div>
  );
};

export default PaymentOptionSkeleton;
export { PaymentOptionSkeletonProps };
